export default __webpack_public_path__ + "static/media/logo.446f313d.png";